import React, { FC, ReactNode } from "react";

export interface SectionHeroProps {
  className?: string;
  rightImg: string;
  heading: ReactNode;
  subHeading: string;
  btnText: string;
}

const SectionHeroTentangIPI: FC<SectionHeroProps> = ({
  className = "",
  rightImg,
  heading,
  subHeading,
  btnText,
}) => {
  return (
    <div
      className={`nc-SectionHero relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        <div className="w-screen max-w-full space-y-5 lg:space-y-7">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
            {heading}
          </h2>
          <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            {subHeading}
          </span>
         <p>
          <ul>
            <li>✔️ Komunitas Ibu Pembelajar Indonesia berdiri pada tanggal 23 Oktober 2021</li>
            <li>✔️ Community Development berbasis pemberdayaan Ibu</li>
            <li>✔️ Membangun kerjasama strategis dengan semua sektor khususnya Pendidikan</li>
            <li>✔️ Asas komunitas adalah asas kegotongroyongan serta sharing pengetahuan dan pengasuhan</li>
            <li>✔️ Tujuan komunitas untuk meningkatkan kualitas diri para Ibu Indonesia</li>
         </ul>
         </p>
        </div>
      </div>
    </div>
  );
};

export default SectionHeroTentangIPI;
